import data from "./organization-data.json"

const getOrganization = (slug) => {
    const brand = data.brands[slug]
    if (!brand) return null
    const holding = brand.holding === true ? data.holding : brand.holding
    const sameAs = [
        ...(brand.sharedSocials === true ? data.sharedSocials : []),
        ...(brand.brandSocials ?? [])
    ]
    return {...holding, name: brand.name, "@id": brand.id , sameAs,}
}

export default getOrganization